interface PriceFormattingOptions {
    price: number;
    lang: string;
    currency?: string;
    notation?: Intl.NumberFormatOptions['notation'];
    digits?: boolean;
}
const formatPrice = ({
    price,
    lang = 'fr',
    currency = 'EUR',
    notation = 'standard',
    digits = false,
}: PriceFormattingOptions) => {
    const options: Intl.NumberFormatOptions = {
        style: 'currency',
        currency,
        notation,
    };
    if (!digits && notation !== 'compact') {
        options.minimumFractionDigits = 0;
        options.maximumFractionDigits = 0;
    }
    return new Intl.NumberFormat(lang, options).format(Number(price));
};

export const formatAdPriceForMap = ({ price, lang }: Pick<PriceFormattingOptions, 'price' | 'lang'>) => {
    const options = {
        notation: 'compact',
        roundingOptions: 'ceil',
    };
    // https://github.com/microsoft/TypeScript/issues/52072#issuecomment-1709012036
    return new Intl.NumberFormat(lang, options as Intl.NumberFormatOptions)
        .format(Number(price))
        .replace(/\s/g, '')
        .toUpperCase();
};

export default formatPrice;
